var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"ma-0 pa-0 d-flex flex-column overflow-hidden",attrs:{"fluid":"","id":"app-wrapper"}},[_c('toolbar',{attrs:{"id":"app-bar"}}),_c('div',{staticClass:"d-flex justify-center overflow-y-auto",attrs:{"id":"page-body"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }